import type { LocalizedPageContent } from "./spanishPageContent";
export const ENGLISH_TOOL: LocalizedPageContent["tool"] = {
  inputAriaLabel: "Bio text input",
  inputPlaceholder: "Enter your name or bio text...",
  fontHeading: "Aesthetic Font Styles",
  templateHeading: "Aesthetic Bio Templates",
  random: "Random",
  emptyPreviewText: "name",
  symbolsHeading: "Aesthetic Symbols",
  symbolsAriaLabel: "Decoration symbol shortcuts",
  beforeLabel: "Add before your bio",
  beforePlaceholder: "Symbols placed before your text, e.g. ♡ ✧",
  afterLabel: "Add after your bio",
  afterPlaceholder: "Symbols placed after your text, e.g. ✧ ♡",
  previewHeading: "Aesthetic Bio Preview",
  copied: "Copied!",
  copy: "Copy Aesthetic Bio",
  copyAriaLabel: "Copy",
};
